// @flow

export function debounce<T, AV, A: Array<AV>>(
  func: (...args: A) => T,
  threshold?: number = 100,
  execAsap?: boolean,
) {
  let timeout;

  return function debounced(...args: A) {
    const obj = this;

    function delayed() {
      if (!execAsap) {
        func.apply(obj, args);
      }

      timeout = null;
    }

    if (timeout) {
      clearTimeout(timeout);
    } else if (execAsap) {
      func.apply(obj, args);
    }

    timeout = setTimeout(delayed, threshold);
  };
}

export default debounce;



// WEBPACK FOOTER //
// ./src/common/utils/debounce.js